import React, { useEffect, useRef, useState } from "react";
import {
  MAIN_URL,
  getApiCall,
  getApiCallForVideo,
  postApiCall,
  postFormApiCall,
} from "../../utils/api";
import MaterialTable from "material-table";
import tableIcons from "../component/MaterialIcon";
import { ThemeProvider, createTheme } from "@mui/material";
import { Delete, Edit } from "@material-ui/icons";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
import { Modal } from "@material-ui/core";
import {
  CircleSpinnerOverlay,
  FerrisWheelSpinner,
} from "react-spinner-overlay";
import Papa from "papaparse";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const contentList = [
  { id: "video", label: "Videos" },
  { id: "reading", label: "Reading Materials" },
  { id: "worksheet", label: "Worksheets" },
  { id: "question", label: "Quiz" },
];

const QrDataPage = () => {
  const defaultMaterialTheme = createTheme();
  const [selectedRow, setSelectedRow] = useState(null);
  const inputRef = useRef(null);

  const [selectedTypeRows, setSelectedTypeRows] = useState({
    video: [],
    reading: [],
    worksheet: [],
    question: [],
  });

  const [currentSelectingType, setCurrentSelectingType] = useState(null);

  const [data, setData] = useState([]);
  const [qrData, setQrData] = useState([]);
  const [qrId, setQrId] = useState("");

  const [loading, setLoading] = useState(false);

  const [name, setName] = useState("");

  const [isOpen, setIsOpen] = useState(false);

  const [selectedRows, setSelectedRows] = useState([]);

  const [classList, setClassList] = useState([]);
  const [moduleList, setModuleList] = useState([]);
  const [className, setClassName] = useState("");
  const [moduleName, setModuleName] = useState("");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    const classes = await getApiCall("classes/get-all");
    setClassList(classes.data);

    const res = await getApiCall("admin/get-qr-data");
    setData(res.data);

    res.data.forEach((data, index) => {
      data.serial = index + 1;
    });
    setLoading(false);
  };
  const onClassChange = async (val) => {
    setLoading(true);
    const boardRes = await postApiCall("module/get-by-class", { id: val });
    setModuleList(boardRes.data);
    setModuleName("");
    setLoading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();
    formData.append("id", qrId);
    formData.append("name", name);
    formData.append("selected_data", JSON.stringify(selectedTypeRows));

    let res = {};
    if (qrId === "") {
      res = await postFormApiCall("admin/add-qr-data", formData);
    } else {
      // res = await postFormApiCall("worksheets/update", payload);
    }

    setLoading(false);
    if (!res.success) {
      return Swal.fire({ title: "Error", text: res.message, icon: "error" });
    }
    Swal.fire({ title: "Successful", text: res.message, icon: "success" });
    setName("");
    setQrId("");
    setSelectedTypeRows({
      video: [],
      reading: [],
      worksheet: [],
      question: [],
    });
    fetchData();
  };

  // const onDataTypeChange = async (val) => {
  //   if (moduleName === "") {
  //     return Swal.fire({
  //       title: "Error",
  //       text: "Please select module",
  //       icon: "error",
  //     });
  //   }
  //   setLoading(true);
  //   const res = await postApiCall("admin/get-qr-type", {
  //     type: val,
  //     module_id: moduleName,
  //   });
  //   setQrData(res.data);
  //   res.data.forEach((data, index) => {
  //     data.serial = index + 1;
  //   });
  //   setSelectedRows([]);
  //   setLoading(false);
  //   setIsOpen(true);
  // };

  // let navigate = useNavigate();

  const onDataTypeChange = async (val) => {
    if (moduleName === "") {
      return Swal.fire({
        title: "Error",
        text: "Please select module",
        icon: "error",
      });
    }
    setLoading(true);
    const res = await postApiCall("admin/get-qr-type", {
      type: val,
      module_id: moduleName,
    });
    res.data.forEach((data, index) => {
      data.serial = index + 1;
    });
    setQrData(res.data);
    setCurrentSelectingType(val);
    setIsOpen(true);
    setLoading(false);
  };
  // Inside modal Set button logic:
  const handleSetSelected = () => {
    setSelectedTypeRows((prev) => ({
      ...prev,
      [currentSelectingType]: qrData
        .filter((item) => selectedRows.includes(item.id))
        .map((item) => item.id),
    }));
    setIsOpen(false);
    setSelectedRows([]);
    setQrData([]);
    setCurrentSelectingType(null);
  };

  const [openView, setOpenview] = useState(false);
  const [viewData, setViewData] = useState([]);
  const handleNameClick = async (rowData) => {
    const res = await postApiCall("admin/get-qr-data-by-type", {
      id: rowData.id.toString(),
    });

    if (res.data.length <= 0)
      return Swal.fire({
        title: "Error",
        text: "No Data found",
        icon: "error",
      });
    setOpenview(true);
    setViewData(res.data);
  };
  const columns = [
    {
      title: "Sl. no",
      field: "serial",
    },
    {
      title: "Name",
      field: "name",
      render: (rowData) => (
        <div
          style={{
            color: "blue",
            cursor: "pointer",
            textDecoration: "underline",
          }}
          onClick={() => handleNameClick(rowData)}
        >
          {rowData.name}
        </div>
      ),
    },
    {
      title: "Image",
      field: "thumbnail_path",
      render: (rowData) => {
        return (
          <>
            <img
              src={MAIN_URL + rowData.qr_path}
              height={150}
              width={150}
              alt="thumbnail"
            />
          </>
        );
      },
    },
  ];
  const dataColumn = [
    {
      title: "Sl. no",
      field: "serial",
      cellStyle: {
        width: "5%",
      },
    },
    {
      title: "Title",
      field: "name",
    },
  ];

  const handleEdit = async (rowData) => {
    setQrId(rowData.id);
    setName(rowData.name);
    onDataTypeChange(rowData.type);

    inputRef.current.focus();
    const input = document.getElementById("boardInput");
    input.focus();
  };

  const handleDelete = async (rowData) => {
    new Swal({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const res = await postApiCall("admin/delete-qr-data", {
          id: rowData.id,
        });
        if (res.success === false) {
          return Swal.fire({
            title: "Error",
            text: res.message,
            icon: "error",
          });
        }
        Swal.fire({
          title: "Successful",
          text: res.message,
          icon: "success",
        });
        fetchData();
      }
    });
  };

  return (
    <div>
      {/* <Modal
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
          setSelectedRows([]);
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: "white",
              padding: "1rem",
              borderRadius: "8px",
              minWidth: "80%",
              maxHeight: "90vh",
              overflowY: "auto",
            }}
          >
            <div className="row">
              <div className="col-md-12 mt-4">
                <div className="card card-primary">
                  <ThemeProvider theme={defaultMaterialTheme}>
                    <MaterialTable
                      icons={tableIcons}
                      title="Worksheets"
                      columns={dataColumn}
                      data={qrData}
                      
                      onSelectionChange={(rows) => {
                        setSelectedRows(rows.map((r) => r.id));
                      }}
                      options={{
                        selection: true, 
                        exportButton: true,
                        actionsColumnIndex: -1,
                        headerStyle: {
                          backgroundColor: "rgb(0 123 255)",
                          color: "#FFF",
                          fontSize: 18,
                        },
                        rowStyle: (rowData) => ({
                          backgroundColor: selectedRow?.includes(
                            rowData.tableData.id
                          )
                            ? "#d3d4d1"
                            : "#FFF",
                        }),
                      }}
                    />
                  </ThemeProvider>
                </div>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "1rem",
                gap: "0.5rem",
              }}
            >
              <button
                onClick={() => {
                  setIsOpen(false);
                  setSelectedRows([]);
                }}
                style={{
                  padding: "8px 16px",
                  backgroundColor: "#ccc",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                Close
              </button>
              <button
                onClick={() => setIsOpen(false)}
                style={{
                  padding: "8px 16px",
                  backgroundColor: "#007bff",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                Set
              </button>
            </div>
          </div>
        </div>
      </Modal> */}

      <Modal open={isOpen} onClose={() => setIsOpen(false)}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: "white",
              padding: "1rem",
              borderRadius: "8px",
              minWidth: "80%",
              maxHeight: "90vh",
              overflowY: "auto",
              position: "relative",
            }}
          >
            {/* 🔴 Close Button */}
            <button
              onClick={() => setIsOpen(false)}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                background: "transparent",
                border: "none",
                fontSize: "20px",
                cursor: "pointer",
              }}
              title="Close"
            >
              &times;
            </button>

            <ThemeProvider theme={defaultMaterialTheme}>
              <MaterialTable
                icons={tableIcons}
                title={`Select ${currentSelectingType}`}
                columns={[{ title: "Title", field: "name" }]}
                data={qrData}
                onSelectionChange={(rows) =>
                  setSelectedRows(rows.map((r) => r.id))
                }
                options={{
                  selection: true,
                  paging: false,
                  exportButton: false,
                  headerStyle: {
                    backgroundColor: "rgb(0 123 255)",
                    color: "#FFF",
                    fontSize: 16,
                  },
                }}
              />
            </ThemeProvider>

            {/* Action buttons (optional) */}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "1rem",
                gap: "0.5rem",
              }}
            >
              <button
                onClick={() => setIsOpen(false)}
                style={{
                  padding: "8px 16px",
                  backgroundColor: "#ccc",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                Close
              </button>
              <button
                onClick={handleSetSelected}
                style={{
                  padding: "8px 16px",
                  backgroundColor: "#007bff",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                Set
              </button>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        open={openView}
        onClose={() => {
          setOpenview(false);
          setViewData([]);
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: "white",
              padding: "1rem",
              borderRadius: "8px",
              minWidth: "80%",
              maxHeight: "90vh",
              overflowY: "auto",
            }}
          >
            <div style={{ width: "100%", padding: "20px" }}>
              <h2>QR Data</h2>

              {viewData.length > 0 ? (
                viewData.map((section, idx) => (
                  <div key={idx} style={{ marginBottom: "20px" }}>
                    <h4
                      style={{ textTransform: "capitalize", color: "#007bff" }}
                    >
                      {section.type}
                    </h4>
                    {section.data.map((item, index) => (
                      <p key={item.id}>
                        {index + 1}. {item.name}
                      </p>
                    ))}
                  </div>
                ))
              ) : (
                <p>No data available.</p>
              )}
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "1rem",
                gap: "0.5rem",
              }}
            >
              <button
                onClick={() => {
                  setOpenview(false);
                  setViewData([]);
                }}
                style={{
                  padding: "8px 16px",
                  backgroundColor: "#ccc",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </Modal>

      <div className="content-wrapper">
        <div className="content-header" style={{ backgroundColor: "#faebd7" }}>
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h4 className="m-0">Worksheets</h4>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <Link to="/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Worksheets</li>
                </ol>
              </div>
            </div>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              {/* left column */}
              <div className="col-md-12 mt-4">
                {/* general form elements */}
                <div className="card card-primary">
                  <div className="card-header">
                    <h3 className="card-title">
                      {qrId === "" ? "Add" : "Edit"} Worksheets
                    </h3>
                  </div>

                  <form onSubmit={handleSubmit} enctype="multipart/form-data">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-4 col-sm-12">
                          <div className="form-group">
                            <label htmlFor="boardInput">
                              {qrId === "" ? "Add" : "Edit"} Title
                            </label>
                            <input
                              type="text"
                              onChange={(e) => setName(e.target.value)}
                              className="form-control"
                              id="boardInput"
                              placeholder="Enter title"
                              ref={inputRef}
                              value={name}
                              name="name"
                              required
                            />
                          </div>
                        </div>

                        <div className="col-md-4 col-sm-12">
                          <div class="form-group">
                            <label for="selectInput">
                              {qrId === "" ? "Select" : "Edit"} Class
                            </label>
                            <select
                              class="custom-select form-select rounded-0"
                              id="selectInput"
                              onChange={(e) => {
                                setClassName(e.target.value);
                                onClassChange(e.target.value);
                              }}
                              required
                              value={className}
                              name="class_id"
                            >
                              <option value="" disabled selected>
                                Select an option
                              </option>
                              {classList.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-md-4 col-sm-12">
                          <div class="form-group">
                            <label for="selectInput">
                              {qrId === "" ? "Select" : "Edit"} Module
                            </label>
                            <select
                              class="custom-select form-select rounded-0"
                              id="selectInput"
                              onChange={(e) => {
                                setModuleName(e.target.value);
                                // onModuleChange(e.target.value);
                              }}
                              required
                              value={moduleName}
                              name="module_id"
                            >
                              <option value="" disabled selected>
                                Select an option
                              </option>
                              {moduleList.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.module_name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        {/* Buttons to select data for each content type */}
                        {contentList.map((item) => (
                          <div className="col-md-3" key={item.id}>
                            <button
                              type="button"
                              className="btn btn-info btn-block"
                              onClick={() => onDataTypeChange(item.id)}
                            >
                              Select {item.label}
                            </button>
                            {selectedTypeRows[item.id].length > 0 && (
                              <small className="text-success">
                                {selectedTypeRows[item.id].length} selected
                              </small>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="card-footer">
                      <button type="submit" className="btn btn-primary mt-3">
                        {qrId === "" ? "Submit" : "Update"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="content mt-4">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12 mt-4">
                <div className="card card-primary">
                  <ThemeProvider theme={defaultMaterialTheme}>
                    <MaterialTable
                      icons={tableIcons}
                      title="Worksheets"
                      columns={columns}
                      data={data}
                      onRowClick={(evt, selectedRow) =>
                        setSelectedRow(selectedRow.tableData.id)
                      }
                      options={{
                        exportButton: true,
                        exportCsv: (columns, data) => {
                          // Extract column titles
                          const columnTitles = columns.map((col) => col.title);

                          // Build CSV rows
                          const csvData = data.map(
                            (row) => columns.map((col) => row[col.field] ?? "") // handle undefined fields
                          );

                          // Combine into a full CSV
                          const csv = Papa.unparse({
                            fields: columnTitles,
                            data: csvData,
                          });

                          // Create and trigger file download
                          const blob = new Blob([csv], {
                            type: "text/csv;charset=utf-8;",
                          });
                          const url = URL.createObjectURL(blob);
                          const link = document.createElement("a");
                          link.href = url;
                          link.setAttribute("download", "qrdata.csv");
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                        },
                        exportPdf: (columns, data) => {
                          const doc = new jsPDF();
                          const tableColumnTitles = columns.map(
                            (col) => col.title
                          );
                          const tableRows = data.map((row) =>
                            columns.map((col) => row[col.field] ?? "")
                          );

                          autoTable(doc, {
                            head: [tableColumnTitles],
                            body: tableRows,
                            styles: { fontSize: 8 },
                            headStyles: { fillColor: [0, 123, 255] },
                          });

                          doc.save("qrdata.pdf");
                        },
                        actionsColumnIndex: -1,
                        headerStyle: {
                          backgroundColor: "rgb(0 123 255)",
                          color: "#FFF",
                          fontSize: 18,
                        },
                        rowStyle: (rowData, index) => ({
                          backgroundColor:
                            selectedRow === rowData.tableData.id
                              ? "#d3d4d1"
                              : index % 2 !== 0
                              ? "#EEE"
                              : "#FFF",
                        }),
                      }}
                      actions={[
                        // {
                        //   icon: () => (
                        //     <span style={{ color: "#5656ce" }}>
                        //       <Edit />
                        //     </span>
                        //   ),
                        //   tooltip: "Edit",
                        //   onClick: (event, rowData) => handleEdit(rowData),
                        // },
                        (rowData) => ({
                          icon: () => (
                            <span style={{ color: "#5656ce" }}>
                              <Delete />
                            </span>
                          ),
                          tooltip: "Delete",
                          onClick: (event, rowData) => handleDelete(rowData),
                        }),
                      ]}
                    />
                  </ThemeProvider>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <CircleSpinnerOverlay
        loading={loading}
        overlayColor="rgba(0,153,255,0.2)"
      />
    </div>
  );
};

export default QrDataPage;
